import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// Auto-reload on stale chunk errors after deploy
const RELOAD_KEY = "__chunk_reload__";
function isChunkErrorMessage(msg: string): boolean {
  return (
    /Failed to fetch dynamically imported module/i.test(msg) ||
    /Loading chunk \d+ failed/i.test(msg) ||
    /Importing a module script failed/i.test(msg) ||
    /Failed to load module script/i.test(msg) ||
    /ChunkLoadError/i.test(msg)
  );
}
function tryReloadOnce() {
  try {
    if (sessionStorage.getItem(RELOAD_KEY)) return;
    sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
  } catch {
    // ignore
  }
  window.location.reload();
}
window.addEventListener("vite:preloadError", (e) => {
  e.preventDefault();
  tryReloadOnce();
});
window.addEventListener("error", (e) => {
  const msg = e?.message || (e?.error instanceof Error ? e.error.message : "");
  if (msg && isChunkErrorMessage(msg)) tryReloadOnce();
});
window.addEventListener("unhandledrejection", (e) => {
  const reason: any = e?.reason;
  const msg = reason instanceof Error ? reason.message : String(reason ?? "");
  if (msg && isChunkErrorMessage(msg)) tryReloadOnce();
});

createRoot(document.getElementById("root")!).render(<App />);
